(function () {
    'use strict';

    angular
        .module('FormBuilder')
        .directive('fbFieldMultichoice', fbFieldMultichoiceDirective);

    const defaultTemplateUrl = 'common/app/components/form/question-set/column/multichoice';

    function fbFieldMultichoiceDirective($templateCache, lodash) {
        return {
            restrict: 'EA',
            scope: {
                element: "=",
                model: '='
            },
            template: function(elem, attr) {
                var templateUrl = lodash.get(attr, 'template', '');
                if (lodash.isEmpty(templateUrl)) {
                    return $templateCache.get(defaultTemplateUrl);
                }
                var template = $templateCache.get(templateUrl);
                if (lodash.isEmpty(template)) {
                    return $templateCache.get(defaultTemplateUrl);
                }
                return template;
            },
            controller: fbFieldMultichoiceDirectiveCtrl,
            controllerAs: 'vm',
            bindToController: true
        };
    }

    function fbFieldMultichoiceDirectiveCtrl(lodash, FbQuestionWrapperService) {
        var vm = this;
        this.$onInit = function() {
            vm.selectable = true;
            vm.setModel = setModel;

            vm.showTextBox = function() {
                return FbQuestionWrapperService.showTextbox(vm);
            };
            vm.onBlur = function($event) {
                if (vm.showText()) {
                    FbQuestionWrapperService.onBlur(vm, $event.target);
                }
            };


            if (lodash.has(vm.element,'options.settings.showText')) {
                vm.showText = '<fb-field-show-text-field element="vm.element" model="vm.model"></fb-field-show-text-field>';
            }
        }


        function setModel() {
            var _ans = [];
            var count = 0;
            for (var i in vm.element.options.choices) {
                if (vm.element.options.choices[i].selected) {
                    _ans.push(vm.element.options.choices[i].value);
                    count++;
                }
            }

            checkForMax(count);

            vm.model.answer = _ans;
        }

        function checkForMax(count) {
            var max_selection = lodash.get(vm.element, 'options.settings.max_selection', null);
            if (max_selection) {
                if (count >= max_selection) {
                    vm.selectable = false;
                } else {
                    vm.selectable = true;
                }
            }
        }
    }
})();